module.exports = __webpack_public_path__ + "media/jason_de_ridder-kalm.066fc84e.mp4";